import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { pushPage } from '@shared/actions';

import getSearchedLocation from '@location/selectors/getSearchedLocation';
import getCart from '@core/reducers/cart/selectors/getCart';
import getMenuWithDiscounts from '@core/reducers/menu/selectors/getMenuWithDiscounts';

import getShop from '@core/reducers/shop/selectors/getShop';
import getShopId from '@core/reducers/shop/selectors/getShopId';

import { getIsDesktopLayout, getUserId } from '@shared/selectors';
import getBusinessTypeFromQuery from '@shared/selectors/getBusinessTypeFromQuery';

import initializeCart from '@core/reducers/cart/actions/initCart';

import fetchMenu from '@core/reducers/menu/actions/fetchMenu';
import register from '@conversion/register';
import registerShopDetails from '@shopDetails/register';
import getIsShelvesMenuLayout from '@core/reducers/menu/selectors/getIsShelvesMenuLayout';
import getGroceriesTabSelected from '@shopDetails/selectors/getGroceriesTabSelected';
import fetchShopByLink from '@core/reducers/shop/actions/fetchShopByLink';
import getIsMenuFetched from '@core/reducers/menu/selectors/getIsMenuFetched';
import getHasFetchedShop from '@core/reducers/shop/selectors/getHasFetchedShop';
import getSessionId from '@core/reducers/user/selectors/getSessionId';
import { trackShopDetailsLoaded } from '@conversion/tracking/actions/trackShopDetailsLoaded';
import getIsInitializingCart from '@core/reducers/cart/selectors/getIsInitializingCart';
import getIsOccasionPickup from '@core/reducers/shop/selectors/getIsOccasionPickup';

register();
registerShopDetails();

const mapStateToProps = createStructuredSelector({
  searchedLocation: getSearchedLocation,
  cart: getCart,
  shop: getShop,
  shopId: getShopId,
  userId: getUserId,
  menu: getMenuWithDiscounts,
  hasFetchedMenu: getIsMenuFetched,
  hasFetchedShop: getHasFetchedShop,
  isShelvesMenuLayout: getIsShelvesMenuLayout,
  sessionId: getSessionId,
  groceriesTabSelected: getGroceriesTabSelected,
  isDesktopLayout: getIsDesktopLayout,
  businessTypeFromQuery: getBusinessTypeFromQuery,
  isInitializingCart: getIsInitializingCart,
  isPickupFilter: getIsOccasionPickup,
});

const mapDispatchToProps = {
  fetchMenu,
  initializeCart,
  fetchShopByLink,
  pushPage,
  trackShopDetailsLoaded,
};

const withIntl = connect(mapStateToProps, mapDispatchToProps);

export default withIntl;
